/**
 * Error page shown when authentication token is invalid or missing
 */

export function ErrorPage() {
  return (
    <div className="container">
      <div className="form-section" style={{ textAlign: 'center', marginTop: '100px' }}>
        <h1>⚠️ Invalid Access Link</h1>
        <p>The link you used to access this form is invalid or has expired.</p>
        <p>Please contact your administrator for a new access link.</p>

        <div style={{ marginTop: '40px', fontSize: '14px', color: 'var(--color-text-secondary)' }}>
          <p>If you believe this is an error, please check:</p>
          <ul style={{ textAlign: 'left', display: 'inline-block', marginTop: '10px' }}>
            <li>The complete URL was copied (including the token parameter)</li>
            <li>The link has not expired</li>
            <li>You're accessing the link from the correct device</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
